const style = {
  wrapper: {
    // background: `#2B2B2B`
    background: `#252525`
  }
}

export default style



// WEBPACK FOOTER //
// ./src/components/partials/Footer/style/main.js